import store from '@/store';
const brandsConfig = require('./brands.json');
const { VUE_APP_ENVIROMENT } = process.env;

const getFacetsConfiguration = () => {
  const brandConfig =
    brandsConfig[store.getters.getActiveBrand][VUE_APP_ENVIROMENT];

  const allowedConfig = {};
  //  GET CONFIG FILE
  if (brandConfig.facetConfigFile) {
    const facetConfigFile = require(`./${brandConfig.facetConfigFile}`);

    Object.entries(facetConfigFile).forEach(([key, property]) => {
      if (store.state.user?.roles && property.roles) {
        const isAllowed = store.getters.allowAction(property.roles);

        if(!isAllowed) return;
      }
      if (property.hideFieldWhen) {
        const isAllowed = store.getters.allowField(property.hideFieldWhen);

        if (!isAllowed) return;
      }

      allowedConfig[key] = property;
    });
  }

  return allowedConfig;
};

const getDataTableHeadersConfiguration = () => {
  const brandConfig =
    brandsConfig[store.getters.getActiveBrand][VUE_APP_ENVIROMENT];

  //  GET CONFIG FILE
  const allowedConfig = [];
  if (brandConfig.tableConfig) {
    const configHeader = require(`./${brandConfig.tableConfig}`);

    configHeader.forEach((property) => {
      if (property.roles) {
        const isAllowed = store.getters.allowAction(property.roles);

        if (!isAllowed) return;
      }
      if (property.hideFieldWhen) {
        const isAllowed = store.getters.allowField(property.hideFieldWhen);

        if (!isAllowed) return;
      }

      allowedConfig.push(property);
    });
  }

  return allowedConfig;
};

export { getFacetsConfiguration, getDataTableHeadersConfiguration };
